import { useQuery } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { ServiceVendorId } from '@/services/api/petseo.client.wrapper';
import { vendorServiceKeys } from '@petseo/shared';

interface UseServicesOptions {
  includeInactive?: boolean;
}

export const useServices = (serviceVendorId: ServiceVendorId, { includeInactive = false }: UseServicesOptions = {}) => {
  return useQuery({
    queryKey: vendorServiceKeys.forVendor(serviceVendorId),
    queryFn: async () => {
      const response = await serviceVendorsClient.getServiceVendorServicesEndpoint(serviceVendorId);
      return response.data;
    },
    select: (data) => {
      const services = data.services ?? [];
      return includeInactive ? services : services.filter((s) => s.isActive !== false);
    },
    enabled: !!serviceVendorId,
  });
};
